import axios from 'axios';
import moment from 'moment';

export const sendInvoices = async ({ reportsData, repCurrency, payPeriod }) => {
  const currencyData = {
      PLN: {
        url: 'https://api.nbp.pl/api/exchangerates/tables/a/',
        path: [
          'data',
          0,
          'rates',
          (arr) => arr.find((r) => r.code === 'USD'),
          'mid',
        ],
        symbol: 'zł',
        bank: 'NBP',
      },
      UAH: {
        url: 'https://bank.gov.ua/NBUStatService/v1/statdirectory/exchange?json',
        path: ['data', (arr) => arr.find((r) => r.cc === 'USD'), 'rate'],
        symbol: '₴',
        bank: 'NBU',
      },
    },
    resolvePath = (obj, path) => {
      return path.reduce((acc, step) => {
        if (acc === undefined || acc === null) return undefined;
        if (typeof step === 'function') return step(acc);
        return acc[step];
      }, obj);
    };

  const ratesResp = await axios.get(currencyData[`${repCurrency}`].url);
  const usdRate = resolvePath(ratesResp, currencyData[`${repCurrency}`].path);

  const getWorkdaysInMonth = () => {
    const month = moment(payPeriod, 'MMM YYYY').format('MM');
    let workdays = 0;
    let date = new Date(payPeriod.split(' ')[1], month - 1, 1);

    while (date.getMonth() === month - 1) {
      let day = date.getDay();
      if (day !== 0 && day !== 6) workdays++;
      date.setDate(date.getDate() + 1);
    }

    return workdays;
  };

  const calcMonthCapacity = (assigneeCap) =>
    getWorkdaysInMonth() *
    (assigneeCap === 'Part-time+' ? 6 : assigneeCap === 'Part-time' ? 4 : 8);

  const getTotalHrs = (projects) =>
    projects.map((p) => Object.values(p)[0]).reduce((a, b) => a + b, 0);

  const getExtra = (data) => `${data.extra}${data.extraCurrency}`;
  const calcExtra = (data) =>
    data.extraCurrency === '$' ? +data.extra * usdRate : +data.extra;

  const calcSalary = (data) =>
    data.assignee.wage
      ? `(${getTotalHrs(data.projects)}h of ${data.assignee.wage}$/m = ${(
          (getTotalHrs(data.projects) * data.assignee.wage) /
          (data.assignee.specialty === 'DevOps'
            ? +data.assignee.capacity
            : calcMonthCapacity(data.assignee.availability))
        ).toFixed(2)}$) x ${usdRate}${currencyData[`${repCurrency}`].symbol} (${
          currencyData[`${repCurrency}`].bank
        }) = ${(
          ((getTotalHrs(data.projects) * data.assignee.wage) /
            (data.assignee.specialty === 'DevOps'
              ? +data.assignee.capacity
              : calcMonthCapacity(data.assignee.availability))) *
          usdRate
        ).toFixed(2)}${currencyData[`${repCurrency}`].symbol}${
          data.assignee.extra
            ? ` + ${getExtra(data.assignee)} (extra payment) = ${(
                ((getTotalHrs(data.projects) * data.assignee.wage) /
                  (data.assignee.specialty === 'DevOps'
                    ? +data.assignee.capacity
                    : calcMonthCapacity(data.assignee.availability))) *
                  usdRate +
                calcExtra(data.assignee)
              ).toFixed(2)}${currencyData[`${repCurrency}`].symbol}`
            : ''
        }`
      : `(${getTotalHrs(data.projects)}h x ${data.assignee.rate}$/h = ${(
          getTotalHrs(data.projects) * data.assignee.rate
        ).toFixed(2)}$) x ${usdRate}${currencyData[`${repCurrency}`].symbol} (${
          currencyData[`${repCurrency}`].bank
        }) = ${(
          getTotalHrs(data.projects) *
          data.assignee.rate *
          usdRate
        ).toFixed(2)}${currencyData[`${repCurrency}`].symbol}${
          data.assignee.extra
            ? ` + ${getExtra(data.assignee)} (extra payment) = ${(
                getTotalHrs(data.projects) * data.assignee.rate * usdRate +
                calcExtra(data.assignee)
              ).toFixed(2)}${currencyData[`${repCurrency}`].symbol}`
            : ''
        }`;

  reportsData.forEach((r) => {
    r.receivers.forEach(async (receiver) => {
      const messageData = {
        channel: receiver,
        preview: 'Salary report is available!',
        blocks: [
          {
            type: 'section',
            text: {
              type: 'mrkdwn',
              text: `*${r.assignee.firstName} ${
                r.assignee.lastName
              } - salary report for ${payPeriod}*\n\n${r.projects
                .map(
                  (p) =>
                    `${Object.entries(p)[0][0]} - ${
                      Object.entries(p)[0][1]
                    } hr(s)`,
                )
                .join('\n')}\n\n*Total:* ${calcSalary(r)}`,
            },
          },
        ],
      };

      try {
        await axios.post(
          `${
            process.env.VUE_APP_NODE_ENV === 'production'
              ? 'https://jupiplus.com'
              : 'http://localhost:3000'
          }/api/publish-message`,
          messageData,
        );
      } catch (err) {
        return err.response;
      }
    });
  });
};
